import {
    DMARC_EFFECTIVENESS_FAILURE,
    DMARC_EFFECTIVENESS_REQUEST,
    DMARC_EFFECTIVENESS_SUCCESS,
} from './types/dmarc-effectiveness-action-types';
import { prevDmarcEffectivenessParamsSelector } from '../selectors/dmarc-effectiveness-selectors';

import ReportService from '../../common/services/reports-service';
import axios from 'axios';
import { isEqual } from 'lodash';

function requestDmarcEffectiveness( params ){
    return {
        params,
        type: DMARC_EFFECTIVENESS_REQUEST,
    };
}
function receiveDmarcEffectiveness( data ){
    return {
        payload: data,
        type: DMARC_EFFECTIVENESS_SUCCESS,
    };
}
function dmarcEffectivenessError( error ){
    return {
        error,
        type: DMARC_EFFECTIVENESS_FAILURE,
    };
}

function fetchDmarcEffectiveness( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( requestDmarcEffectiveness( params ) );

        const reportService = new ReportService( DATA_API );

        return reportService.getDmarcEffectiveness( params )
            .then(
                ( response ) => dispatch( receiveDmarcEffectiveness( response.data ) ),
                ( error = {} ) => {
                    if( !axios.isCancel( error ) ){
                        return dispatch( dmarcEffectivenessError( error.response ) );
                    }
                }
            );
    };
}

export function fetchDmarcEffectivenessIfNeeded( params ){
    return ( dispatch, getState ) => {
        const prevParams = prevDmarcEffectivenessParamsSelector( getState() );

        if( !isEqual( params, prevParams ) ){
            return dispatch( fetchDmarcEffectiveness( params ) );
        }
        else{
            return Promise.resolve();
        }
    };
}
